import React from 'react';
// import { Navigate, useParams } from "react-router-dom";

// import {
//   Grid, 
//   Button,
// } from "@mui/material";

// import { ModelBase, PlayerObject } from '../../../../models';
// import { 
//   Sense, 
// } from "../../models";

// import LoadingBox from '../../../../components/input/LoadingBox';

// import API from "../../utilities/system_api";
// import DataUtilities from "../../../../utilities/common_utilities";
// import ModelBaseInput from '../../components/ModelBaseInput';

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();

export default function SenseEdit() {
  // const { id } = useParams();
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  // const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  // const [navigateTo, setNavigateTo] = useState<string | null>(null);
  // const [obj, setObj] = useState<Sense>(api.working_on_sb === null ? new Sense() : new Sense({ source_books: [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }] }));
  // const [change_time, setChangeTime] = useState(0);
  
  // const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  // useEffect(() => {
  //   if (!fetched) {
  //     load();
  //   }
  // });
    
  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  // const load = () => {
  //   setFetched(true);
  //   if (id && id !== "") {
  //     setLoading(true);
  //     const onComplete = (res: PlayerObject[] | ModelBase[]) => {
  //       if (res.length === 1 && res[0] instanceof Sense) {
  //         setObj(res[0].clone());
  //         setChangeTime(common_util.get_time_number());
  //       }
  //       setLoading(false);
  //     };
  //     const onProgress = () => {};
  //     api.getObjectsWithCallbacks({ 
  //       data_type: "sense", filter: { _id: id },
  //       onComplete, onProgress 
  //     });
  //   }
  // }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("sense", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/sense");
  //     });
  //   }
  // }

  // const height = window.innerHeight - 120;
  // if (!fetched || loading) {
  //   return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  // } else if (navigateTo !== null) {
  //   return <Navigate to={navigateTo} />;
  // } else { 
  //   return (
  //     <Grid container spacing={0} direction="row">
  //       <Grid item xs={12}>
  //         <div style={{ height, overflowY: "scroll" }}>
  //           <ModelBaseInput 
  //             obj={obj}
  //             disabled={disabled}
  //             change_time={change_time}
  //             onChange={(changed: ModelBase) => {
  //               if (changed instanceof Sense) {
  //                 const new_obj = obj;
  //                 new_obj.copy(changed);
  //                 setObj(new_obj);
  //                 setChangeTime(common_util.get_time_number());
  //               }
  //             }}
  //           />
  //         </div>
  //       </Grid>
  //       { !disabled &&
  //         <Grid item xs={12}>
  //           <Button
  //             variant="contained"
  //             color="primary"
  //             disabled={processing}
  //             onClick={submit}>
  //             Submit
  //           </Button>
  //           <Button
  //             variant="contained"
  //             disabled={processing}
  //             style={{ marginLeft: "4px" }}
  //             onClick={ () => { 
  //               setNavigateTo(`/dandd/language`);
  //             }}>
  //             Cancel
  //           </Button>
  //         </Grid>
  //       }
  //     </Grid>
  //   ); 
  // }
  return <></>
}